import { logPageTiming } from '../apis/GoogleAnalyticsApi';

/**
 * PageLoadLogger utility class
 *
 * An instance of this class can be used during a 'page load' to wait for any initial promises to complete and then send a user timing event to
 * Google Analytics as a 'page timing' (logPageTiming above).
 *
 * Each component in the app creates an instance of this class and calls capture() after its initial ajax loading has finished.
 */
class PageLoadLogger {
  requests = [Promise.resolve()];

  /**
   * Create a new PageLoadLogger
   * @param {String} pageName The page name which will be sent to google analytics.
   */
  constructor(pageName) {
    this.pageName = pageName;
    this.start = new Date().getTime();
  }

  /**
   * Adds a request to the list of captured requests. The page timing will not be called until all promises have completed.
   * @param {*} promise
   */
  addRequest(promise) {
    this.requests.push(promise);
  }

  /**
   * Logs the page timing as soon as all requests are complete. If no requests have been added, logs immediately.
   */
  async capture() {
    return Promise.all(this.requests).then(() => {
      logPageTiming(this.pageName, new Date().getTime() - this.start);
    });
  }
}

export default PageLoadLogger;



// WEBPACK FOOTER //
// ./src/utils/PageLoadLogger.js